import { render, staticRenderFns } from "./zwYuyueModal.vue?vue&type=template&id=452d4745&"
import script from "./zwYuyueModal.vue?vue&type=script&lang=js&"
export * from "./zwYuyueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports